import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { SearchModel } from 'src/app/models/search-model';
import { ArgusApiService } from 'src/app/services/argus-api.service';

@Component({
  selector: 'app-search-model',
  templateUrl: './search-model.component.html',
  styleUrls: ['./search-model.component.scss']
})
export class SearchModelComponent implements OnInit {
  searchControl: FormControl = new FormControl('', [Validators.required, Validators.minLength(3)]);
  result: SearchModel;
  isLoading = false;
  
  loadingPriceTxt = "Estimation du prix en cours...";

  constructor(private argusService: ArgusApiService) { }

  ngOnInit(): void {
  }

  onSubmit() {
    if (this.searchControl.value.length > 0) {
      this.result = null;
      this.isLoading = true;
      this.argusService.searchModel({searched_model: this.searchControl.value})
        .toPromise()
        .then((res: SearchModel) => this.result = res)
        .finally(() => this.isLoading = false)
    }
  }

}
